<template>
  <div class="map">
    <div id="container" ref="container"></div>
    <div id="panel" ref="panel"></div>
    <div id="myPageTop">
      <table>
        <tr>
          <td>
            <label>请输入关键字：</label>
          </td>
        </tr>
        <tr>
          <td>
            <input v-model="keyWords" id="tipinput" />
            <button @click="searchAddress(this.keyWords)">搜索</button>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
var map, placeSearch;
export default {
  name: "Map",
  props: [],
  data() {
    return {
      address: "",
      keyWords: "请输入地址"
    };
  },
  created() {
    this.address = this.$route.query.address;
    // this.address = this.$store.getters.getAddress;
    console.log("路由传过来的地址", this.address);
  },
  updated() {
    if (this.address != "") {
      this.mapInit();
    }
  },
  mounted() {
    this.mapInit();
    this.$nextTick(() => this.searchAddress("心田花开学校" + this.address));

    // this.searchAddress("心田花开学校" + this.address);
  },
  methods: {
    mapInit() {
      let that = this;
      map = new AMap.Map(this.$refs.container, {
        resizeEnable: true,
        zoom: 10
      });
      AMap.service(["AMap.PlaceSearch"], function() {
        //构造地点查询类
        placeSearch = new AMap.PlaceSearch({
          pageSize: 5, // 单页显示结果条数
          pageIndex: 1, // 页码
          citylimit: false, //是否强制限制在设置的城市内搜索
          map: map, // 展现结果的地图实例
          panel: that.$refs.panel, // 结果列表将在此容器中进行展示。
          autoFitView: true, // 是否自动调整地图视野使绘制的 Marker点都处于视口的可见范围
          renderStyle: "default"
        });
      });
      // 添加列表点选监听事件
      try {
        AMap.event.addListener(
          placeSearch,
          "selectChanged",
          this.selectAddress
        );
      } catch (error) {
        setTimeout(() => {
          location.reload();
        }, 1000);
      }
    },
    searchAddress(params) {
      placeSearch.search(params);
    },
    selectAddress(e) {
      //这里获得点选地点的经纬度
      let location = e.selected.data.location;
      console.log("lng", location.lng);
      console.log("lat", location.lat);
      // Do Something
    }
  }
};
</script>
<style lang="less">
.map {
  height: 100%;
  #container {
    width: 100%;
    height: 100%;
  }
  #panel {
    position: absolute;
    background-color: white;
    max-height: 90%;
    overflow-y: auto;
    top: 180px;
    right: 50px;
    width: 300px;
  }
  #myPageTop {
    position: absolute;
    top: 100px;
    right: 50px;
    background: #fff;
  }
  table {
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 3px 6px rgba(235, 235, 235, 0.5);
    border-radius: 10px;
    width: 300px;
    // background: chartreuse;
    input {
      width: 210px;
      margin-right: 10px;
      text-indent: 10px;
    }
  }
}
</style>